import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DownloadPdfRequest = {
  collectionIssueId: number;
};

export type DownloadPdfsResponse = {};

export const downloadPdf = async (request: DownloadPdfRequest) => {
  await executeApiRequest(async () => {
    const response = await axios.get(`/collectionevents/${request.collectionIssueId}/downloadpdf`, {
      responseType: "blob"
    });
    const blobData = new Blob([response.data]);
    const url = window.URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${request.collectionIssueId}.pdf`);
    document.body.appendChild(link);
    link.click();

    return response;
  }, false);
};
